import React from 'react';
import PropTypes from 'prop-types';
import DownArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import './DownIconButton.styl';
import theme from 'styles/theme';

export default class DownIconButton extends React.PureComponent {
  render() {
    const {onClick, color = theme.palette.grey} = this.props;
    return (
      <div className="down-icon-button pointer">
        {/* This icon has a lot of extra space around it making the border look bad */}
        {/* working around that with a separate div that we just overlay on the svg */}
        <div className="border" style={{borderColor: color}}>
          <DownArrow className="down-arrow" onClick={onClick} color={color} />
        </div>
      </div>
    );
  }
}

DownIconButton.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.string,
};
